var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7866 1.40039L4.49993 6.66706M4.09993 1.40039H12.8999C13.6333 1.40039 14.2333 2.00039 14.2333 2.73372V4.20039C14.2333 4.73372 13.8999 5.40039 13.5666 5.73372L10.6999 8.26706C10.2999 8.60039 10.0333 9.26706 10.0333 9.80039V12.6671C10.0333 13.0671 9.7666 13.6004 9.43327 13.8004L8.49994 14.4004C7.63327 14.9337 6.43327 14.3337 6.43327 13.2671V9.73372C6.43327 9.26706 6.1666 8.66706 5.89994 8.33372L3.3666 5.66706C3.03327 5.33372 2.7666 4.73372 2.7666 4.33372V2.80039C2.7666 2.00039 3.3666 1.40039 4.09993 1.40039Z",
    stroke: "#023E8A",
    strokeOpacity: 0.7,
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.aba8b399a6649910451736227b1c9f0a.svg";
export { ForwardRef as ReactComponent };